import { useErrandsServiceGetV1IndividualsByIndividualIdErrands } from '../client/queries'

export const useErrands = (individualId?: string) => {
  return useErrandsServiceGetV1IndividualsByIndividualIdErrands(
    { individualId: individualId! },
    undefined,
    { enabled: !!individualId },
  )
}
